var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55001 4.73999L11.9175 2.61749C14.775 1.66499 16.3275 3.22499 15.3825 6.08249L13.26 12.45C11.835 16.7325 9.49501 16.7325 8.07001 12.45L7.44001 10.56L5.55001 9.92999C1.26751 8.50499 1.26751 6.17249 5.55001 4.73999Z",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58252 10.2375L10.2675 7.54504",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconBlack);
export default __webpack_public_path__ + "static/media/sendIconBlack.cbd3d609fc4d1d67f2c7f0190663021a.svg";
export { ForwardRef as ReactComponent };